import { IIcon } from './iconConstants'
const BuildingLatestIcon = (props: IIcon) => {
  return (
    <svg width='33' height='32' viewBox='0 0 33 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M22.218 29.273V5.124a2.283 2.283 0 0 0-3.129-2.117L8.659 7.18a2.282 2.282 0 0 0-1.434 2.118v19.976c0 .54.438.978.978.978H21.24a.977.977 0 0 0 .978-.978zM20.262 5.124v23.171H9.181V9.297a.326.326 0 0 1 .205-.303l10.43-4.172a.327.327 0 0 1 .446.302z'
        fill={props?.fill}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M30.04 29.273V12.325a2.282 2.282 0 0 0-2.282-2.282H21.24a.977.977 0 0 0-.978.978v18.252c0 .541.438.978.978.978h7.822a.978.978 0 0 0 .978-.978zm-1.956-16.948v15.97h-5.866V12l5.54-.001a.326.326 0 0 1 .326.326z'
        fill={props?.fill}
      />
      <path
        d='M31.67 28.296H5.595a.978.978 0 1 0 0 1.955H31.67a.978.978 0 0 0 0-1.956zM12.113 12.65h5.215a.978.978 0 0 0 0-1.956h-5.215a.977.977 0 1 0 0 1.956zm0 4.563h5.215a.978.978 0 0 0 0-1.955h-5.215a.978.978 0 1 0 0 1.955zm0 4.563h5.215a.978.978 0 0 0 0-1.956h-5.215a.977.977 0 1 0 0 1.956zm0 4.563h5.215a.978.978 0 0 0 0-1.956h-5.215a.977.977 0 1 0 0 1.956z'
        fill={props?.fill}
      />
      <rect y='2.182' width='14.747' height='14.747' rx='7.373' fill='#fff' />
      <path
        d='M7.373 3.637a5.919 5.919 0 1 1 0 11.838 5.919 5.919 0 0 1 0-11.838zm0 1.303a4.615 4.615 0 1 0-.003 9.23 4.615 4.615 0 0 0 .003-9.23zm0 6.597a.652.652 0 1 1 .001 1.303.652.652 0 0 1-.001-1.303zm0-5.266a.652.652 0 0 1 .652.65v3.161a.652.652 0 0 1-1.303 0v-3.16a.652.652 0 0 1 .65-.651z'
        fill={props?.fill}
        stroke={props?.stoke}
        strokeWidth='.25'
      />
    </svg>
  )
}
export default BuildingLatestIcon
